module.exports = __webpack_public_path__ + "static/media/features-home-element-03.76be6a89.png";